import React from "react";
import Logo from "../components/Logo";
import "./PrivacyPolicy.css";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <main className="privacy">
      <div className="privacy-header">
        <Link to={"/"} className="privacy-logo">
          <Logo />
        </Link>
        <h1>Privacy Policy</h1>
      </div>
      <div className="privacy-content">
        <p>
          <strong>Effective Date:</strong> 2nd Jan, 2025
        </p>

        <h2>Introduction</h2>
        <p>
          Welcome to Restrix App. This Privacy Policy explains how we collect,
          use, and protect your information when you use our app. By using
          Restrix App, you agree to the terms of this Privacy Policy.
        </p>

        <h2>Features and Data Usage</h2>
        <p>Our app provides the following features:</p>
        <ul>
          <li>
            <strong>See visual displays of app usage information:</strong> Data
            about your app usage is stored locally and not shared with third
            parties.
          </li>
          <li>
            <strong>
              Instantly block any app(s) for a specific time period:
            </strong>{" "}
            We store your block preferences locally.
          </li>
          <li>
            <strong>
              Schedule app blocks for multiple days at specified times:
            </strong>{" "}
            Scheduling data is stored locally on your device.
          </li>
          <li>
            <strong>Instantly hide or unhide apps on your device:</strong> This
            feature uses on-device settings only; no data is transmitted.
          </li>
          <li>
            <strong>Prevent app installation:</strong> Preferences are managed
            on your device and not shared externally.
          </li>
          <li>
            <strong>Prevent app removal:</strong> Settings are applied locally
            on your device.
          </li>
          <li>
            <strong>Restrict access to specific websites:</strong> Website
            restriction settings are managed locally and are not transmitted to
            external servers.
          </li>
        </ul>

        <h2>Data Collection and Sharing</h2>
        <p>
          We do not collect or share personal or sensitive user data. All
          features are managed locally on your device. No data is transmitted to
          external servers.
        </p>

        <h2>Security</h2>
        <p>
          We prioritize your privacy and take steps to protect your information.
          However, no app can guarantee absolute security.
        </p>

        <h2>Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Changes will be
          reflected in the app or on our website.
        </p>

        <h2>Contact Us</h2>
        <p>
          If you have questions about this Privacy Policy, please contact us at{" "}
          <a className="store-link" href="mailto:ignitedcodeart@gmail.com">ignitedcodeart@gmail.com</a>.
        </p>
      </div>
    </main>
  );
};

export default PrivacyPolicy;
